export default __webpack_public_path__ + "static/15_UncannyValleyBoy-ea4cb62ace49877fe73049f5f93a98b6.pdf";